export function transformToPayoutOptions(data) {
    return Object.assign({}, data);
}
